import React, { Fragment, useContext, useEffect, useState } from 'react';
import formatNumber from '../../../../../fns/formatNumber';
import Button from '../../../../../components/Button/ProgressiveButton';
import PureButton from '@material-ui/core/Button';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import { store } from './reducer';
import { store as mainStore } from '../../../../../store';
import CheckIcon from '@material-ui/icons/Check';
import LinkIcon from '@material-ui/icons/Link';
import { useHistory } from 'react-router-dom';
import axios from '../../../../../api/axios';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { isMobile } from 'react-device-detect';
import LicensePlate from './LicensePlate';
import { CircularProgress } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: isMobile ? '1fr' : '2fr 8fr',
    gridGap: theme.spacing(1),
    padding: theme.spacing(2),
    background: '#efefef',
  },
  actions: {
    display: 'grid',
    gridTemplateColumns: isMobile ? '1fr 1fr' : '1fr 1fr 1fr 1fr',
    gridGap: theme.spacing(1),
  },
  main: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridGap: theme.spacing(1),
  },
}));

const PaymentItem = ({ payment, fullname, userId, orderId, driver }) => {
  const classes = useStyles();
  const { dispatch, state, actions, refresh } = useContext(store);
  const { showMessage, showError } = useContext(mainStore);
  const { order, bidders } = state;
  const payers = order?.payers;
  const history = useHistory();
  const [credit, setCredit] = useState(null);
  const [progress, setProgress] = useState(false);
  const [loadingReadyWayBill, setLoadingReadyWayBill] = useState(false);

  const showWalletDialog = () => {
    dispatch({
      type: 'SHOW_PAYMENT_DIALOG',
      payload: { payment, userId, orderId, paymentType: 'wallet', credit },
    });
  };
  const showCashDialog = () => {
    dispatch({
      type: 'SHOW_PAYMENT_DIALOG',
      payload: { payment, userId, orderId, paymentType: 'cash' },
    });
  };
  const handleAddReadyWaybill = async () => {
    setLoadingReadyWayBill(true);
    try {
      const data = await actions.addReadyWaybill(orderId, userId);
      if (data.ok) {
        showMessage(data.messages);
        refresh();
      }
    } catch (error) {
      showError(error);
    } finally {
      setLoadingReadyWayBill(false);
    }
  };
  const fetchUserCredit = async () => {
    try {
      const { data } = await axios.get(`/api/v1/admin/users/credit/${userId}`);
      if (data.ok) {
        setCredit(data.credit);
      }
    } catch (error) {
      showError(error);
    }
  };
  const handleSendPaymentLink = async () => {
    try {
      setProgress(true);
      const { data } = await axios.post(`/api/v1/admin/users/sendIPGLink`, {
        userId,
        amount: formatNumber(payment),
        tracingCode: order?.tracingCode,
        orderId,
      });
      if (data?.ok) {
        showMessage(data?.messages);
      }
    } catch (error) {
      showError(error);
    }
    setProgress(false);
  };
  const handleClickCard = (e) => {
    history.push(
      `/protected/admin/users/${driver?._id ? `driver` : `customer`}/${userId}`
    );
  };

  useEffect(() => {
    userId && fetchUserCredit();
  }, [userId]);

  return (
    <Card>
      <CardActionArea>
        <div className={classes.root}>
          <div className={classes.main}>
            <Typography component="div" variant="h3" onClick={handleClickCard}>
              {fullname}
            </Typography>
            <Typography component="div" variant="body1">
              {`مبلغ پرداختنی: ${formatNumber(payment)} تومان`}
            </Typography>
          </div>
          {!driver?.numberPlate && (
            <div>
              <LicensePlate bidders={bidders} driver={driver} />
            </div>
          )}
          {driver?.numberPlate && (
            <CardActions className={classes.actions}>
              <PureButton
                variant="contained"
                color="secondary"
                size="large"
                startIcon={<CreditCardIcon />}
                onClick={showCashDialog}
                disabled={payers?.includes(userId)}
                style={credit < 0 ? { background: 'red' } : null}
              >
                پرداخت نقدی
              </PureButton>
              <PureButton
                variant="contained"
                color="secondary"
                size="large"
                startIcon={<AccountBalanceWalletIcon />}
                onClick={showWalletDialog}
                disabled={payers?.includes(userId)}
                style={credit < 0 ? { background: 'red' } : null}
              >
                پرداخت از کیف ‌پول
              </PureButton>
              {driver?._id && (
                <PureButton
                  variant="contained"
                  color="secondary"
                  size="large"
                  startIcon={<CheckIcon />}
                  disabled={
                    !payers?.includes(userId) ||
                    order?.readyWaybills?.includes(driver._id) ||
                    loadingReadyWayBill
                  }
                  endIcon={
                    loadingReadyWayBill ? (
                      <CircularProgress size={'10px'} />
                    ) : (
                      <></>
                    )
                  }
                  onClick={handleAddReadyWaybill}
                >
                  صدور
                </PureButton>
              )}
              {!payers?.includes(userId) && (
                <Button
                  variant="contained"
                  color="secondary"
                  size="large"
                  startIcon={<LinkIcon />}
                  style={{ background: 'green' }}
                  onClick={handleSendPaymentLink}
                  disabled={progress}
                >
                  ارسال لینک پرداخت
                </Button>
              )}
            </CardActions>
          )}
        </div>
      </CardActionArea>
    </Card>
  );
};

export default React.memo(PaymentItem);
